export default __webpack_public_path__ + "static/media/MARKS 6 RS.ec27cedc.png";